import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import isString from 'lodash/isString';
import partial from 'lodash/partial';
/**
 * Adds keyboard support and select functionality to a StandardMenu item
 */ export function itemWithOnSelect(item, onSelect) {
    return _object_spread_props(_object_spread({}, item), {
        onClick: (e)=>{
            // I would use optional chaining here, but `npm run test` doesn't like it
            if (item.onClick) {
                item.onClick(e);
            }
            if (onSelect) {
                onSelect(item.value, item.label);
            }
        }
    });
}
/** For use with `mapDropdownItemsToIndexes` */ function buildIndexForDropdownGroupItem(index, previousGroupValue, groupItem, groupInnerIndex) {
    return groupItem.label && isString(groupItem.label) ? _object_spread_props(_object_spread({}, previousGroupValue), {
        [groupItem.label]: {
            index,
            innerIndex: groupInnerIndex,
            selected: groupItem.selected
        }
    }) : previousGroupValue;
}
/** For use with `mapDropdownItemsToIndexes` */ function buildIndexesForDropdownGroup(index, previousValue, item) {
    return _object_spread({}, previousValue, item.items.reduce(partial(buildIndexForDropdownGroupItem, index), {}));
}
/** For use with `mapDropdownItemsToIndexes` */ function buildIndexForDropdownOption(index, previousValue, item) {
    return _object_spread_props(_object_spread({}, previousValue), {
        [item.label]: {
            index,
            innerIndex: null,
            selected: item.selected
        }
    });
}
/**
 *  Because our StandardMenu is made up of `DropdownItem`s (which can be a `DropdownOption` or a `DropdownGroup`),
 * tracking what index is currently focused is difficult.
 *
 *  This function flattens a `DropdownItem[]` by mapping each item's label to the index that said item exists within
 * the menu's root (returned object's `index` value) and stores a separate index that indicates where it exists within
 * a DropdownGroup (return object's `innerIndex` value)
 *
 * If `innerIndex` is null, the item exists at the menu's root.
 */ export function mapDropdownItemsToIndexes(items) {
    return items.reduce((previousValue, item, index)=>{
        const isLabelValidString = item.label && isString(item.label);
        const isDropdownItemAGroup = !!item.items;
        if (isLabelValidString || isDropdownItemAGroup) {
            if (item.items) {
                return buildIndexesForDropdownGroup(index, previousValue, item);
            } else if (isString(item.label)) {
                return buildIndexForDropdownOption(index, previousValue, item);
            }
        }
        return previousValue;
    }, {});
}

//# sourceMappingURL=utils.js.map